// LocationSection.tsx
import React from "react";
import { Location } from "./types";

interface LocationSectionProps {
  locations: Location[];
  selectedLocation: Location | null;
  onSelectLocation: (location: Location) => void;
}

const LocationSection: React.FC<LocationSectionProps> = ({
  locations,
  selectedLocation,
  onSelectLocation,
}) => {
  return (
    <section id="location">
      <h2>Selecciona la Ubicación</h2>

      <ul className="service-list">
        {locations.map((location) => (
          <li
            key={location.id}
            className={`location-item service-item ${
              selectedLocation?.id === location.id ? "selected-step" : ""
            }`}
            onClick={() => onSelectLocation(location)}
          >
            <h4>{location.name}</h4>
            <p>{location.address}</p>
            <p
              style={{
                fontSize: "0.9rem",
                color: "var(--color-accent)",
                fontWeight: 700,
              }}
            >
              {location.schedule}
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default LocationSection;
